/* eslint-disable react-native/no-inline-styles */
import React from 'react';
import { Image } from 'react-native';

import { isWeb, isNative } from '@global/screens';
import { imageSource } from '@global/helpers';

import PropTypes from 'prop-types';

const propTypes = {
  source: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.string,
    PropTypes.number,
  ]),
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  compressWidth: PropTypes.number,
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

const defaultProps = {
  source: '',
  width: 0,
  compressWidth: 0,
  height: 0,
};

const defaultImg = require('@/assets/img/default/image-default.png');

const ImageContain = ({
  source = '',
  width = 0,
  compressWidth = isWeb ? 250 : 100,
  height = 0,
}) => {
  let imageUrl = { uri: imageSource(source, compressWidth) };
  if (!source) {
    if (isNative) {
      imageUrl = { uri: Image.resolveAssetSource(defaultImg).uri };
    } else {
      imageUrl = { uri: defaultImg };
    }
  }

  return (
    <Image
      width={width}
      height={height}
      style={{ width: width, height: height }}
      resizeMode="contain"
      source={imageUrl}
      defaultSource={defaultImg}
    />
  );
};

ImageContain.propTypes = propTypes;
ImageContain.defaultProps = defaultProps;

export default ImageContain;
